import { combineEpics } from 'redux-observable';
import { appEpics } from './appEpics';

const rootEpic = combineEpics(appEpics);

export default rootEpic;
